export function enumToOptions<T extends Record<string, string | number>>(
  enumObj: T,
): Array<{ label: string; value: T[keyof T] }> {
  return (Object.keys(enumObj) as Array<keyof T>).map((key) => ({
    label: key as string,
    value: enumObj[key],
  }));
}
